module.exports = __webpack_public_path__ + "images/fd-career-tracks.jpg";